import React from 'react';
import { X, Smartphone, Printer } from 'lucide-react';

const BillTypeModal = ({ isOpen, onClose, onEBill, onPaperBill, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          disabled={isLoading}
        >
          <X className="w-6 h-6" />
        </button>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Select Bill Type
        </h2>

        {/* Options */}
        <div className="space-y-4">
          {/* E-Bill Option */}
          <button
            onClick={onEBill}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-4 p-6 border-2 border-blue-500 rounded-lg hover:bg-blue-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed group"
          >
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
              <Smartphone className="w-8 h-8 text-blue-600" />
            </div>
            <div className="flex-1 text-left">
              <h3 className="text-xl font-semibold text-gray-800">E-Bill</h3>
              <p className="text-sm text-gray-600">Send receipt via SMS</p>
            </div>
          </button>

          {/* Paper Bill Option */}
          <button
            onClick={onPaperBill}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-4 p-6 border-2 border-green-500 rounded-lg hover:bg-green-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed group"
          >
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
              <Printer className="w-8 h-8 text-green-600" />
            </div>
            <div className="flex-1 text-left">
              <h3 className="text-xl font-semibold text-gray-800">Paper Bill</h3>
              <p className="text-sm text-gray-600">Print physical receipt</p>
            </div>
          </button>
        </div>

        {isLoading && (
          <div className="mt-4 text-center text-sm text-gray-600">
            Processing...
          </div>
        )}
      </div>
    </div>
  );
};

export default BillTypeModal;
